import React from 'react';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import RegistrationFormProps from '../registration.types';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/styles';
import colors from '../../../themes/main-colors';
import { ResidentialIcon } from './ResidentialIcon';
import { BusinessIcon } from './BusinessIcon';
import { useTranslation } from '../../../hooks/useTranslation';
import { OnlineRegistrationType } from '../../../__generated__/pge-types';

const useStyles = makeStyles(() =>
  createStyles({
    registrationTypeBox: {
      border: `1px solid ${colors.lightGray}`,
      backgroundColor: colors.white,
      borderRadius: '0px',
      textAlign: 'center',
      fontSize: '0.875rem',
      cursor: 'pointer',
      fontFamily: 'Untitled-Sans',
      transition: 'all 0.2s',
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      justifyContent: 'center',
      padding: '8px 12px',
      fontWeight: 600,
    },
    selectedRegistrationTypeBox: {
      fontWeight: 600,
      color: colors.white,
      backgroundColor: colors.sparkBlue,
    },
  }),
);

interface AccountSectionProps extends RegistrationFormProps {
  classes: any;
}

const AccountTypeToggle = (props: AccountSectionProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { form } = props;
  return (
    <Box>
      <Grid>
        <Typography variant={'h2'}>{t('ACCOUNT_PICKER_TEXT')}</Typography>
      </Grid>
      <Grid
        container
        direction="row"
        justify="space-between"
        css={{ margin: '16px 0 24px 0' }}
      >
        <Box
          className={clsx(
            classes.registrationTypeBox,
            form.values.registrationType ===
              OnlineRegistrationType.Residential &&
              classes.selectedRegistrationTypeBox,
          )}
          onClick={() =>
            form.setValue(
              'registrationType',
              OnlineRegistrationType.Residential,
            )
          }
        >
          <ResidentialIcon
            isSelected={
              form.values.registrationType ===
              OnlineRegistrationType.Residential
            }
          />
          <span css={{ padding: '5px 0 0 8px' }}>{t('RESIDENTIAL')}</span>
        </Box>
        <Box
          className={clsx(
            classes.registrationTypeBox,
            form.values.registrationType ===
              OnlineRegistrationType.Commercial &&
              classes.selectedRegistrationTypeBox,
          )}
          onClick={() => {
            void form.setValue(
              'registrationType',
              OnlineRegistrationType.Commercial,
            );
            void form.setValue('primaryAccountOption', 'accountNumber');
          }}
        >
          <BusinessIcon
            isSelected={
              form.values.registrationType === OnlineRegistrationType.Commercial
            }
          />
          <span css={{ padding: '0 0 0 8px' }}>{t('BUSINESS')}</span>
        </Box>
      </Grid>
    </Box>
  );
};

export default AccountTypeToggle;
